import { UserProfile } from '@/features/Auth/auth.types'
import { profileService } from '@/services'
import { queryOptions } from '@tanstack/react-query'
import { getUser } from '@/features/Auth/auth.hooks'

export async function getUserProfile(): Promise<UserProfile> {
  return profileService.getProfile()
}

export const userProfileQueryKey = ['userProfile'] as const

export const createUserProfileQueryOptions = (enabled: boolean = true) => {
  const user = getUser()
  return queryOptions({
    queryKey: userProfileQueryKey,
    enabled: enabled && !!user,
    queryFn: getUserProfile,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
  })
}
